import Combat from './combat.webp';
import Left from './left.webp';
import Office from './office.webp';
import Puzzle from './puzzle.webp';
import Right from './right.webp';
import Sewer from './Sewer.webp';

export default {
    Combat,
    Left,
    Office,
    Puzzle,
    Right,
    Sewer
}